import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AlteracaoCadastralComponent } from './components/alteracao-cadastral';
import { BeneficiaryBlockComponent } from './components/beneficiary-block/beneficiary-block.component';
import { CancelamentoImediatoComponent } from './components/cancelamento-imediato';
import { DadosDeCobrancaComponent } from './components/dados-de-cobranca';
import { ShowBeneficiaryComponent } from './components/show-beneficiary';
import { TabelaAlteracaoCadastralComponent } from './components/tabela-alteracao-cadastral';
import { TabelaCancelamentoImediatoComponent } from './components/tabela-cancelamento-imediato';

const routes: Routes = [
  { path: 'selecionar-beneficiario', component: TabelaAlteracaoCadastralComponent },
  { path: 'alterar-titular/:id', component: AlteracaoCadastralComponent },
  { path: 'alterar-dependente/:id', component: AlteracaoCadastralComponent },
  { path: 'alterar-plano-titular/:id', component: AlteracaoCadastralComponent },
  { path: 'alterar-plano-dependente/:id', component: AlteracaoCadastralComponent },
  { path: 'visualizar/:id', component: ShowBeneficiaryComponent },
  { path: 'novo-dependente', component: AlteracaoCadastralComponent },
  { path: 'bloquear-beneficiario/:id/:beneficiaryType', component: BeneficiaryBlockComponent },
  { path: 'desbloquear-beneficiario/:id/:beneficiaryType', component: BeneficiaryBlockComponent },
  { path: 'novo-titular', component: AlteracaoCadastralComponent },
  { path: 'dados-de-cobranca', component: DadosDeCobrancaComponent },
  { path: 'cancelamento-imediato/lista', component: TabelaCancelamentoImediatoComponent },
  { path: 'cancelamento-imediato/:id', component: CancelamentoImediatoComponent },
  { path: 'cancelamento-imediato', component: CancelamentoImediatoComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DadosCadastraisRoutingModule {}
